import { TComponent } from "shared/bootstrap";

export interface Widget {
  name: string;
  component: TComponent;
}

const widgets: { [key: string]: TComponent } = {};

export default widgets;

export const registerWidget = (widget: Widget): void => {
  // eslint-disable-next-line no-prototype-builtins
  if (widgets.hasOwnProperty(widget.name))
    throw `widget with name: ${widget.name} already exists`;
  widgets[widget.name] = widget.component;
};

export const registerWidgets = (widgets: Widget[]): void => {
  widgets.forEach((w): void => registerWidget(w));
};
